<template>
  <section class="top-header  py-3">
    <div
      class="container d-flex justify-content-lg-between justify-content-between align-items-baseline"
    >
      <button
        type="button"
        id="all-categories"
        class="all-categories resp-menu-btn py-1 px-2 d-lg-none"
        @click="$emit('openRespMenu')"
      >
      <svg data-v-ed1c3ebe="" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect data-v-ed1c3ebe="" fill="currentColor" width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect>
        <circle data-v-ed1c3ebe="" fill="currentColor" cx="4" cy="12" r="1"></circle><rect data-v-ed1c3ebe="" fill="#000" x="7" y="11" width="14" height="2" rx=".94" ry=".94"></rect>
        <rect data-v-ed1c3ebe="" fill="currentColor" x="3" y="16" width="18" height="2" rx=".94" ry=".94"></rect>
        <rect data-v-ed1c3ebe="" fill="currentColor" x="3" y="6" width="18" height="2" rx=".94" ry=".94"></rect></svg>      
      </button>
      <div class="d-flex">
        <AtlasLogo />
        <Nav></Nav>
      </div>
      <div class="d-flex">
      <div
        class="d-flex align-items-baseline"
        :class="
          notifications && notifications.items && notifications.items.length
            ? 'ml-4'
            : 'ml-1'
        "
        v-if="mediaQueries.mobileSize"
      >
        <CartButton />
        <SearchButton class="bg-none ml-2 d-md-none" />
        <HeaderNotification
          v-if="notifications"
          v-show="notifications.items && notifications.items.length"
          v-model="notifications"
        />
      </div>

      <div class="headerIcons">
        <!-- نمایش اطلاعات کاربری -->

        <!-- نمایش آیکون اگر لاگین نبود -->
        <button
          v-if="!isLogin"
          type="button"
          class="d-md-inline-block d-none ml-2 log-btn headerIcon"
          data-toggle="modal"
          data-target="#loginModal"
        >
          <!-- <svg
            width="27"
            height="27"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11.5789"
              cy="7.27803"
              r="4.77803"
              stroke="#444"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z"
              stroke="#444"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg> -->
         
          <svg fill="#000000" height="27" width="27" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M256,0c-65.733,0-119.211,53.479-119.211,119.211S190.267,238.423,256,238.423s119.211-53.479,119.211-119.211
			S321.733,0,256,0z M256,218.024c-54.486,0-98.813-44.328-98.813-98.813S201.515,20.398,256,20.398s98.813,44.328,98.813,98.813
			S310.485,218.024,256,218.024z"/>
	</g>
</g>
<g>
	<g>
		<path d="M426.272,331.529c-45.48-45.48-105.952-70.529-170.272-70.529c-64.32,0-124.791,25.047-170.273,70.529
			c-45.48,45.48-70.529,105.952-70.529,170.272c0,5.632,4.566,10.199,10.199,10.199h461.204c5.632,0,10.199-4.567,10.199-10.199
			C496.801,437.482,471.752,377.01,426.272,331.529z M35.831,491.602C41.179,374.789,137.889,281.398,256,281.398
			s214.821,93.391,220.17,210.204H35.831z"/>
	</g>
</g>
<g>
	<g>
		<path d="M182.644,457.944H66.295c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h116.349
			c5.633,0,10.199-4.567,10.199-10.199S188.277,457.944,182.644,457.944z"/>
	</g>
</g>
<g>
	<g>
		<path d="M225.621,457.944h-7.337c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h7.337
			c5.633,0,10.199-4.567,10.199-10.199S231.254,457.944,225.621,457.944z"/>
	</g>
</g>
</svg>
<span class="info">ورود/عضویت</span>
        </button>
        <div
          class="d-flex"
          style="gap:4px"
          :class="
            notifications && notifications.items && notifications.items.length
              ? 'ml-4'
              : 'ml-1'
          "
          v-if="!mediaQueries.mobileSize"
        >
          <button
            type="button"
            class="d-md-inline-block d-none bg-none ml-2 headerIcon"
            @click="showCloseSearchBox()"
          >
            <svg
              width="27"
              height="27"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11.7666"
                cy="11.7666"
                r="8.98856"
                stroke="#444"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.0183 18.4851L21.5423 22"
                stroke="#444"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="info">جستجو</span>
          </button>
          <CartButton />
          <HeaderNotification
            v-if="notifications"
            v-show="
              notifications && notifications.items && notifications.items.length
            "
            v-model="notifications"
          />
        </div>
        <LoginUser
          :class="notifications ? 'mr-3' : 'mr-2'"
          v-if="isLogin"
          :atlasTheme="true"
        />
      </div>
    </div>
    </div>
  </section>
</template>

<script>
import Nav from "@/parts/Front/components/Nav";
import LoginUser from "@/parts/Front/components/LoginUser";
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import { cartListsOpen, openSearch } from "@/libraries/functions";
import findUrl from "@/libraries/links/LinkResolver";
import CartButton from "@/parts/Front/components/cart/CartButton";
import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
import SearchButton from "./header/SearchButton";

export default {
  name: "TopHeader",
  inject: ["mediaQueries"],
  components: {
    SearchButton,
    HeaderNotification,
    CartButton,
    AtlasLogo,
    LoginUser,
    Nav,
  },
  data() {
    return {
      showOptions: false,
    };
  },
  methods: {
    findUrl,
    // cartListsCloseBody(){
    //   const cartLists=document.getElementsByClassName('cart-lists')[0];
    //   const cartListsCloseResp = document.getElementsByClassName('cart-lists-close-resp')[0];
    //   cartListsCloseResp.style.display="none";
    //   cartLists.style.left="-390px";
    // },
    cartListsOpen,
    showCloseSearchBox() {
      openSearch();
    },
  },
  mounted() {},
  computed: {
    menu() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"].menu.header;
      } else {
        return this.$store.getters["front/getHomeData"];
      }
    },
    status() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
  },
};
</script>

<style scoped>
.log-btn {
  position: relative;
  background: transparent;
  /* border-top-left-radius: 25px 25px;
  border-top-right-radius: 25px 25px;
  border-bottom-right-radius: 25px 25px;
  border-bottom-left-radius: 25px 25px; */
  transition: 0.2s;
  color: black;
  padding:0;
}
.headerIcon span.info {
    font-size: 11px;
}

.headerIcon {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}
/* افزودن استایل به کدهای اضافه شده */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.childMenu {
  color: #666;
}
#menuSkelton {
  display: flex;
  justify-content: space-around;
  width: 300px;
}
#menuSkelton div {
  width: 50px;
  height: 30px;
}
.headerIcons{
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.resp-menu-btn {
  background: transparent;
}
</style>
